"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PingbackContext = void 0;
var js_analytics_1 = require("@giphy/js-analytics");
var react_1 = __importStar(require("react"));
exports.PingbackContext = react_1.createContext({});
// aggrigate attributes
var PingbackContextManager = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    var _b = react_1.useContext(exports.PingbackContext).attributes, parentAttributes = _b === void 0 ? {} : _b;
    return (react_1.default.createElement(exports.PingbackContext.Provider, { value: { attributes: js_analytics_1.mergeAttributes(parentAttributes, attributes, 'layout_type') } }, children));
};
exports.default = PingbackContextManager;
//# sourceMappingURL=pingback-context-manager.js.map